import React from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';

import { isVatEnabled } from '~/components/communications/ContactUtils';
import { useContact } from '~/components/Contacts/UpsertContact/useContact';
import PermissionsButtonWrapper from '~/components/core/Permissions/PermissionsButtonWrapper';
import { PERMISSION_ACTIONS, PERMISSION_VERBS } from '~/components/core/Permissions/PermissionUtils';
import Text from '~/components/core/TextComponents/Text';
import RadioButtonFormik from '~/components/RadioButtonFormik';
import { TextFieldFormik } from '~/components/TextFieldFormik';

import { FORMIK_FINANCE_FIELD_IDS } from './constants';
import { getFullFinancePath } from './utils';

const Vat = ({ disabled }) => {
  const { currentCountry } = useContact();
  const { values } = useFormikContext();
  if (!isVatEnabled(currentCountry)) {
    return null;
  }
  const vatLabel = currentCountry === 'AU' ? 'GST' : 'VAT';
  return (
    <div className="grid grid-cols-3 items-center gap-20">
      <Text variant="small" weight="regular">
        {vatLabel} Registered
      </Text>
      <div>
        <PermissionsButtonWrapper action={PERMISSION_ACTIONS.CONTACT_FINANCE_PII} verb={PERMISSION_VERBS.WRITE}>
          <RadioButtonFormik
            id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.IS_VAT_REGISTERED)}
            label="No"
            optionValue={false}
            disabled={disabled}
          />
        </PermissionsButtonWrapper>
        <PermissionsButtonWrapper action={PERMISSION_ACTIONS.CONTACT_FINANCE_PII} verb={PERMISSION_VERBS.WRITE}>
          <RadioButtonFormik
            id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.IS_VAT_REGISTERED)}
            label="Yes"
            optionValue={true}
            disabled={disabled}
          />
        </PermissionsButtonWrapper>
      </div>
      {getIn(values, getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.IS_VAT_REGISTERED)) ? (
        <div>
          <PermissionsButtonWrapper action={PERMISSION_ACTIONS.CONTACT_FINANCE_PII} verb={PERMISSION_VERBS.WRITE}>
            <TextFieldFormik
              id={getFullFinancePath(FORMIK_FINANCE_FIELD_IDS.VAT_NUMBER)}
              label={`${vatLabel} Number`}
              fullWidth
              disabled={disabled}
            />
          </PermissionsButtonWrapper>
        </div>
      ) : null}
    </div>
  );
};

Vat.propTypes = {
  disabled: PropTypes.bool,
};

export default Vat;
